import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ScheduledBigIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 14",
    fill: "currentColor",
    width: size || '24',
    height: size || '14'
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    fill: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02---Thumbnail-Components",
    transform: "translate(-652 -6964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/CalendarBig-1",
    transform: "translate(652 6964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,7 L3,4.5 C3,4.22385763 3.22385763,4 3.5,4 C3.77614237,4 4,4.22385763 4,4.5 L4,7 L6.5,7 C6.77614237,7 7,7.22385763 7,7.5 C7,7.77614237 6.77614237,8 6.5,8 L4,8 L4,10.5 C4,10.7761424 3.77614237,11 3.5,11 C3.22385763,11 3,10.7761424 3,10.5 L3,8 L0.5,8 C0.223857625,8 3.38176876e-17,7.77614237 0,7.5 C-3.38176876e-17,7.22385763 0.223857625,7 0.5,7 L3,7 Z",
    id: "Combined-Shape",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-8",
    stroke: "currentColor",
    x: "10.5",
    y: "1.5",
    width: "13",
    height: "12",
    rx: "1",
    strokeWidth: "1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10",
    fill: "currentColor",
    x: "15",
    y: "0",
    width: "1",
    height: "3",
    rx: ".5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy",
    fill: "currentColor",
    x: "12",
    y: "0",
    width: "1",
    height: "3",
    rx: ".5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-3",
    fill: "currentColor",
    x: "18",
    y: "0",
    width: "1",
    height: "3",
    rx: ".5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-10-Copy-4",
    fill: "currentColor",
    x: "21",
    y: "0",
    width: "1",
    height: "3",
    rx: ".5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-46",
    fill: "currentColor",
    d: "M13 9H15V11H13z",
    fillRule: "evenodd"
  })))));
};
ScheduledBigIcon.displayName = 'ScheduledBigIcon';
export default ScheduledBigIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ScheduledBigIcon.js.map